import { createRef, useEffect, useRef, useState } from "react"
import ClusterModel from "../model/ClusterModel";
import BeaconModel from "../model/BeaconModel";
import { Button, Col, Form, Row } from "react-bootstrap";
import MoveList from "./MoveList";
import positionResultType from "../model/positionResultType";

type propsType = {
    clusterData: ClusterModel[]
    beaconData: BeaconModel[]
    clusterNo: string
    positionLogs: positionResultType[]
    startDetectTime: string
    endDetectTime: string
    mounted: string
    outArea: boolean
}

type beaconPositionType = {
    id: string
    name: string
    x: number
    y: number
}



const Canvas = (props: propsType) => {
    let imgurl:string
  //  let spos: number = 9999;
  //  let spos_buf: number = 9999;
  //  let epos: number = 9999;
    let animetionCallbackId: number;
    let beaconPositionArray: beaconPositionType[] = [];
    //const [sBeaconPositionArray, setBeaconPositionArray] = useState<beaconPositionType[]>([]);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const canvasRef_Line = useRef<HTMLCanvasElement>(null);
    const canvasRef_LineHistory = useRef<HTMLCanvasElement>(null);
    const canvasRef_Icon = useRef<HTMLCanvasElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);
    
    const [mBeforeHeight, setmBeforeHeight] = useState<number>(0);
    const [mBeforeWidth, setmBeforeWidth] = useState<number>(0);
    const [mAfterWidth, setmAfterWidth] = useState<number>(0);
    const [mAfterHeight, setmAfterHeight] = useState<number>(0);
   
    let nextStartLogDate: string;
    const [sNextStartLogDate, setNextStartLogDate] = useState<string>("");
    let loopHandler: number;
    const [sLoopHandler, setLoopHandler] = useState<number>(0);
    const [moveLists, setMovelist] = useState<string[]>([]);
    const moveList: string[] = [];
    const [intervalTime, setIntervalTime] = useState<number>(1000);
    const [lineLength, setLinelength] = useState<number>(10);
    const [speed, setSpeed] = useState<number>(10);
    let line = lineLength;
    let startTime: Date;
    let endTime: Date;
    let moveTime: number;
    let moveCount: number;
    const [sMoveTime, setMoveTime] = useState<number>(0);
    const [sMoveCount, setMoveCount] = useState<number>(0);
    const chara = new Image();
    chara.src = "../image/human.png"

    const [sLogRange, setLogRage] = useState<number>(1);
    const [sIsLoading, setIsLoading] = useState(false);

    let positionLog_buf: positionResultType;
    let startPosition: positionResultType;
    let endPosition: positionResultType;
   
    const getMapContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef.current;
        return canvas.getContext('2d');
    }

    const getLineContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_Line.current;
        return canvas.getContext('2d');
    }

    
    const getLineHistoryContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_LineHistory.current;
        return canvas.getContext('2d');
    }


    const getIconContext = (): CanvasRenderingContext2D => {
        const canvas: any = canvasRef_Icon.current;
        return canvas.getContext('2d');
    }

    const setMapImage = () => {
       
        getBeaconPoint()
        const ctx: CanvasRenderingContext2D = getMapContext();
        const ctx_line_history: CanvasRenderingContext2D = getLineHistoryContext();
        const ctx_line: CanvasRenderingContext2D = getLineContext();
        const ctx_icon: CanvasRenderingContext2D = getIconContext();
        //Map Draw
        imgurl = props.clusterData[Number(props.clusterNo)].image
 
        const img = new Image()
        img.src = imgurl
        

        img.onload = () => {
            const { naturalHeight: beforeHeight, naturalWidth: beforeWidth } = img
           // console.log("H%ixW%i", beforeHeight, beforeWidth)
            const afterWidth: number = 800
            const afterHeight: number = Math.floor(beforeHeight * (afterWidth / beforeWidth))

            setmBeforeHeight(beforeHeight);
            setmBeforeWidth(beforeWidth);
            setmAfterHeight(afterHeight);
            setmAfterWidth(afterWidth);

            //console.log("mAfterHeight:" + mAfterHeight);
            //console.log("mAfterWidth:" + mAfterWidth);

            //各キャンバスのサイズを揃える
            ctx.canvas.width = afterWidth;
            ctx.canvas.height = afterHeight;
            //移動履歴のキャンバス
            ctx_line_history.canvas.width = afterWidth;
            ctx_line_history.canvas.height = afterHeight;
            //移動中のキャンバス
            ctx_line.canvas.width = afterWidth;
            ctx_line.canvas.height = afterHeight;
            //移動アイコンのキャンバス
            ctx_icon.canvas.width = afterWidth;
            ctx_icon.canvas.height = afterHeight;


            //setMoveListHeight(String(afterHeight));

            let canvasContainer = document.getElementById("canvas-container") as HTMLDivElement;
            let cvHeight: string = String(ctx.canvas.height) + "px"
            canvasContainer.style.height = cvHeight

            ctx.drawImage(img, 0, 0, beforeWidth, beforeHeight, 0, 0, afterWidth, afterHeight)
            
            if (props.mounted === "beacon") {
                beaconPositionArray.forEach((beaconPosition: beaconPositionType) => {
                    ctx.beginPath();
                // console.log("X:" + (beaconPosition.x * afterWidth) / beforeWidth)
                // console.log("Y:" + (beaconPosition.y * afterHeight) / beforeHeight)

                    ctx.arc((beaconPosition.x * afterWidth) / beforeWidth, (beaconPosition.y * afterHeight) / beforeHeight, 7, 0 * Math.PI / 180, 360 * Math.PI / 180, false);
                    ctx.fillStyle = "#AADCE7";
                    ctx.fill();
                    ctx.strokeStyle = "#00A2FF";
                    ctx.lineWidth = 3;
                    ctx.stroke();


                    /*
                    // テキストの背景を描画
                    const text = beaconPosition.name; // 描画するテキスト
                    const textWidth = ctx_name.measureText(text).width; // テキストの幅を取得
                    const textX = (beaconPosition.x * afterWidth) / beforeWidth;
                    const textY = (beaconPosition.y * afterHeight) / beforeHeight - 12;

                    let textOffset = textWidth / 2
                    ctx_name.beginPath(); 
                    // テキストの背景を描画
                    let backgroundColor = "rgba(" + [0, 255, 255, 0.4] + ")";
                    ctx.fillStyle = backgroundColor;
                    ctx.fillRect(textX - textOffset , textY - 15, textWidth, 20);


                    ctx_name.font = "bold 13px Roboto medium"
                    ctx_name.textAlign = "center"

                    //let textOffset = textWidth / 2
                    if ((textX - textOffset) > 0 ) {
                        textOffset = 0 
                    }
                    
                    ctx_name.textBaseline = "bottom"
                    ctx_name.fillStyle = "#000000";
                    ctx_name.fillText(text, textX + textOffset, textY)
                    */
                    
                })
            }

            //const canvas: HTMLCanvasElement = document.getElementById("mainCanvas") as HTMLCanvasElement;
            //const tooltip: HTMLElement = document.getElementById("tooltip") as HTMLElement;
            const canvas: HTMLCanvasElement = canvasRef_Icon.current as HTMLCanvasElement;
            const tooltip:HTMLDivElement = tooltipRef.current as HTMLDivElement;
            canvas.addEventListener("mousemove", (event) => {
                const mouseX = event.clientX - canvas.getBoundingClientRect().left;
                const mouseY = event.clientY - canvas.getBoundingClientRect().top;
              
                beaconPositionArray.forEach((circle) => {
                  if (isMouseOverCircle(mouseX, mouseY, circle, afterHeight, beforeHeight, afterWidth, beforeWidth)) {
                    // マウスがサークル上にある場合の処理
                    canvas.style.cursor = "pointer"; // マウスポインタを変更
              
                    //const tooltip = tooltipRef.current as HTMLDivElement;
                    // ツールチップの位置を設定
                    tooltip.style.display = "block";
                    tooltip.style.left = event.pageX + "px";
                    tooltip.style.top = event.pageY + "px";
              
                    // ツールチップにサークルの名前を表示
                    tooltip.innerHTML = circle.name;
                
                  }
                });
              
                if (!beaconPositionArray.some((circle) => isMouseOverCircle(mouseX, mouseY, circle, afterHeight, beforeHeight, afterWidth, beforeWidth))) {
                  // マウスがどのサークルにもない場合の処理
                  canvas.style.cursor = "default"; // マウスポインタを元に戻す
                  tooltip.style.display = "none"; // ツールチップを非表示にする
                }
              });
            
        }
        ctx.save(); 
    }

    const isMouseOverCircle = (x: number, y: number, circle: beaconPositionType, afterHeight: number, beforeHeight: number, afterWidth: number, beforeWidth: number): boolean => {
        const distance = Math.sqrt((x - (circle.x * afterWidth) / beforeWidth) ** 2 + (y - (circle.y * afterHeight) / beforeHeight) ** 2);
        return distance <= 10;
    }

    const getBeaconPoint = () => {
        console.log("getBeaconPoint")
        beaconPositionArray.length = 0;
        props.clusterData[Number(props.clusterNo)].beacons.forEach ((clusterBeacon: any) => {
            props.beaconData.forEach((beacon: BeaconModel) => {
                if(clusterBeacon.id === beacon.id) {
                  //  console.log(beacon.name)
                  //  console.log(beacon.x)
                  //  console.log(beacon.y)
                    let position: beaconPositionType = {
                        id: beacon.id,
                        name: beacon.name, 
                        x: beacon.x,
                        y: beacon.y}
                    
                    beaconPositionArray.push(position)
                }
            })
        })

        //setBeaconPositionArray(beaconPositionArray);
    }

    const drawFirstPoint = (sPosition: positionResultType) => {
        let startX = (sPosition.x * mAfterWidth) / mBeforeWidth;
        let startY = (sPosition.y * mAfterHeight) / mBeforeHeight;
        let ctx_icon = getIconContext();
        
        ctx_icon.clearRect(0,0, ctx_icon.canvas.width, ctx_icon.canvas.height);
        ctx_icon.drawImage(chara, startX, startY - 10, 32, 32);
    }
    
    const drawDeviceMove = (sPosition: positionResultType, ePosition: positionResultType) => {
        startPosition = sPosition;
        endPosition = ePosition;
        // アニメーションを開始
        animate();
    }

    function calculateAngle(x1: number, y1: number, x2: number, y2: number): number {
        // 始点から終点までのXおよびY座標の差を計算
        const dx = x2 - x1;
        const dy = y2 - y1;
    
        // Math.atan2()を使用して角度を計算し、ラジアンから度に変換
        const angleInRadians = Math.atan2(dy, dx);
        const angleInDegrees = angleInRadians * (180 / Math.PI);
    
        // 0から360度の範囲に角度を調整
        const normalizedAngle = (angleInDegrees + 360) % 360;
    
        return normalizedAngle;
    }

    function calculateAngle360(x1: number, y1: number, x2: number, y2: number): number {
        // 始点から終点までのXおよびY座標の差を計算
        const dx = x2 - x1;
        const dy = y2 - y1;
    
        // Math.atan2()を使用して角度をラジアンで計算
        const angleInRadians = Math.atan2(dy, dx);
    
        // ラジアンから度に変換
        let angleInDegrees = angleInRadians * (180 / Math.PI);
    
        // 負の角度を正に変換
        if (angleInDegrees < 0) {
            angleInDegrees += 360;
        }
    
        return angleInDegrees;
    }

   
 
    // アニメーションループ
    function animate() {
       
        //アニメーションフラグ
        let animationFlg: boolean = false;
        // 初期位置
        let startX = (startPosition.x * mAfterWidth) / mBeforeWidth;
        let startY = (startPosition.y * mAfterHeight) / mBeforeHeight;
        let endX = (endPosition.x * mAfterWidth) / mBeforeWidth;
        let endY = (endPosition.y * mAfterHeight) / mBeforeHeight;
        let angleInDegrees = calculateAngle360(startX, startY, endX, endY);
        

        //let ctx = getLineContext();
        // Canvasをクリア
        //ctx.clearRect(0, 0, 800, 800);

        // 矢印付きの線を描画
        animationFlg = drawArrowLine(startX, startY, endX, endY, line, angleInDegrees);

        // 線の長さを更新
        line += speed;
        if (animationFlg) {
            animetionCallbackId = requestAnimationFrame(animate);
        } else {
            startY = 0;
            startY = 0;
            line = lineLength;
            cancelAnimationFrame(animetionCallbackId);
        }
    }

    // 矢印付きの線を描画する関数
    function drawArrowLine(x: number, y: number, lastX: number, lastY: number, length: number, angleDegrees: number):boolean {
        let returnflg = true;
        let ctx = getLineContext();
        let ctx_line_his = getLineHistoryContext();
        let ctx_icon = getIconContext();
        
        const angleRadians = (angleDegrees * Math.PI) / 180;

        
        const endX = x + length * Math.cos(angleRadians);
        const endY = y + length * Math.sin(angleRadians);
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        //console.log("cos1:" + Math.cos(angleRadians))
        //ctx.save();
        //ctx.globalCompositeOperation = "source-atop";

        

        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(endX, endY);
        //ctx.lineTo(lastX, lastY);
        ctx.strokeStyle = "red";
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx_line_his.beginPath();
        ctx_line_his.moveTo(x, y);
        ctx_line_his.lineTo(endX, endY);
        //ctx.lineTo(lastX, lastY);
        ctx_line_his.strokeStyle = "rgba(218,165,32,0.2)";
        ctx_line_his.lineWidth = 2;
        ctx_line_his.stroke();


        ctx_icon.clearRect(0,0, ctx_icon.canvas.width, ctx_icon.canvas.height);
        ctx_icon.drawImage(chara, endX, endY - 10, 32, 32);

        
        let xAbs = Math.abs(Math.cos(angleRadians) - 0.00001);
        let yAbs = Math.abs(Math.sin(angleRadians) - 0.00001);

        if (xAbs <= 0.0001) {
            if (Math.sin(angleRadians) < 0) {
                if (endY < lastY) {
                    returnflg = false
                }
            } else {
                if (endY > lastY) {
                    returnflg = false
                }

            }

        } else if (yAbs <= 0.0001) {
            if (Math.cos(angleRadians) < 0) {
                if (endX < lastX) {
                    returnflg = false
                }
            } else {
                if (endX > lastX) {
                    returnflg = false
                }

            }
        } else {
            if (Math.cos(angleRadians) > 0 && Math.sin(angleRadians) < 0) {
                if (endX > lastX && endY < lastY) {
                    returnflg = false
                }
            }
    
            if (Math.cos(angleRadians) > 0 && Math.sin(angleRadians) > 0) {
                if (endX > lastX && endY > lastY) {
                    returnflg = false
                }
            }
            
            if (Math.cos(angleRadians) < 0  && Math.sin(angleRadians) > 0) {
                if (endX < lastX && endY > lastY) {
                    returnflg = false
                }
            }
    
            if (Math.cos(angleRadians) < 0  && Math.sin(angleRadians) < 0) {
                if (endX < lastX && endY < lastY ) {
                    returnflg = false
                }
            }
        }


        if (!returnflg) {
            drawArrow(ctx, ctx_line_his, endX, endY, angleRadians);
        }

        ctx.restore();

        return returnflg
    }

    function drawArrow(ctx: CanvasRenderingContext2D, ctx_line_his: CanvasRenderingContext2D, endX: number, endY: number, angleRadians: number) {
        const arrowLength = 10; // 矢印の長さ

        ctx.beginPath();
        ctx.moveTo(endX - arrowLength * Math.cos(angleRadians - Math.PI / 6), endY - arrowLength * Math.sin(angleRadians - Math.PI / 6));
        ctx.lineTo(endX, endY);
        ctx.lineTo(endX - arrowLength * Math.cos(angleRadians + Math.PI / 6), endY - arrowLength * Math.sin(angleRadians + Math.PI / 6));
        ctx.fillStyle = "red";
        ctx.fill();
        
        ctx_line_his.beginPath();
        ctx_line_his.moveTo(endX - arrowLength * Math.cos(angleRadians - Math.PI / 6), endY - arrowLength * Math.sin(angleRadians - Math.PI / 6));
        ctx_line_his.lineTo(endX, endY);
        ctx_line_his.lineTo(endX - arrowLength * Math.cos(angleRadians + Math.PI / 6), endY - arrowLength * Math.sin(angleRadians + Math.PI / 6));
        ctx_line_his.fillStyle = "rgba(218,165,32,0.2)";
        ctx_line_his.fill();

    }

    function canvasClear() {
        let line_ctx = getLineContext();
        let map_ctx = getMapContext();
        //let text_ctx = getTextContext();

        line_ctx.clearRect(0, 0, line_ctx.canvas.width, line_ctx.canvas.height);
        map_ctx.clearRect(0, 0, map_ctx.canvas.width, map_ctx.canvas.height);
        //text_ctx.clearRect(0, 0, text_ctx.canvas.width, text_ctx.canvas.height);
    }


    const getPosition = (startLogDate: string) => {
        let startBeaconLogDate = new Date(startLogDate);
        let endBeaconlogDate = new Date(startLogDate);

        //何分後を範囲とするか
        //endBeaconlogDate.setMinutes(endBeaconlogDate.getMinutes() + 1);
        endBeaconlogDate.setSeconds(endBeaconlogDate.getSeconds() + sLogRange);
        moveList.push(startBeaconLogDate.toLocaleString());
        nextStartLogDate = endBeaconlogDate.toString();
        setNextStartLogDate(nextStartLogDate);
      //  console.log("startDate:" + startBeaconLogDate);
      //  console.log("endDate:" + endBeaconlogDate);

        props.positionLogs.forEach((value: positionResultType) => {
            let valuedate = new Date(value.detected);
            if(valuedate.getTime() === startBeaconLogDate.getTime()) {

                let startX = 0;
                let startY = 0;
                let endX = (value.x * mAfterWidth) / mBeforeWidth;
                let endY = (value.y * mAfterHeight) / mBeforeHeight;

                if (positionLog_buf !== undefined) {
                    startX = (positionLog_buf.x * mAfterWidth) / mBeforeWidth;
                    startY = (positionLog_buf.y * mAfterHeight) / mBeforeHeight;
                }
                
                if (props.outArea == false) {
                    if (startX >= 0 && startY >= 0 && endX >= 0 && endY >= 0) {
                        if(startX <= mAfterWidth && startY <= mAfterHeight && endX <= mAfterWidth && endY <= mAfterHeight) {
            
                            line = lineLength;
                            console.log(value);
                            if (positionLog_buf === undefined) {
                                drawFirstPoint(value);
                                moveList.pop();
                                moveList.push(startBeaconLogDate.toLocaleString() + " " + "座標:X " + Math.trunc(value.x) + ",Y " + Math.trunc(value.y) + "から開始")
                            } else {
                                drawDeviceMove(positionLog_buf, value);
                                moveList.pop();
                                moveList.push(startBeaconLogDate.toLocaleString() + " " + "座標:X " + Math.trunc(positionLog_buf.x) + ",Y " + Math.trunc(positionLog_buf.y)  + "から" 
                                + "座標:X " + Math.trunc(value.x) + ",Y " + Math.trunc(value.y) + "へ移動")
                            }
            
                            positionLog_buf = value;
                        }
                    }
                } else {
                    line = lineLength;
                    console.log(value);
                    if (positionLog_buf === undefined) {
                        drawFirstPoint(value);
                        moveList.pop();
                        moveList.push(startBeaconLogDate.toLocaleString() + " " + "座標:X " + Math.trunc(value.x) + ",Y " + Math.trunc(value.y) + "から開始")
                    } else {
                        drawDeviceMove(positionLog_buf, value);
                        moveList.pop();
                        moveList.push(startBeaconLogDate.toLocaleString() + " " + "座標:X " + Math.trunc(positionLog_buf.x) + ",Y " + Math.trunc(positionLog_buf.y)  + "から" 
                        + "座標:X " + Math.trunc(value.x) + ",Y " + Math.trunc(value.y) + "へ移動")
                    }
    
                    positionLog_buf = value;
                }

               
            }        
        })
        setMovelist([...moveLists, ...moveList])
    } 
   
    useEffect(() => {
        console.log("useEffect")
        canvasClear();
        setMapImage();

    },[]);

    const setMoveListHeight = (fixHeight: string) => {
        const listGroup = document.getElementById("list");
        
        if (listGroup) {
            listGroup.style.height = fixHeight + "px";
            console.log("list:" + listGroup.style!.height)
        }   
    }

   
    // 追加: 再生・一時停止状態管理
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    // 追加
    const isPlayingRef = useRef(isPlaying);
    const isPausedRef = useRef(isPaused);

    // 状態変更時にrefも更新
    useEffect(() => { isPlayingRef.current = isPlaying }, [isPlaying]);
    useEffect(() => { isPausedRef.current = isPaused }, [isPaused]);

    // --- Promiseでアニメーションを待つ関数 ---
    const drawDeviceMoveAsync = (sPosition: positionResultType, ePosition: positionResultType): Promise<void> => {
        return new Promise((resolve) => {
            let localStart = { ...sPosition };
            let localEnd = { ...ePosition };
            startPosition = localStart;
            endPosition = localEnd;
            line = lineLength;

            function animateAsync() {
                let startX = (localStart.x * mAfterWidth) / mBeforeWidth;
                let startY = (localStart.y * mAfterHeight) / mBeforeHeight;
                let endX = (localEnd.x * mAfterWidth) / mBeforeWidth;
                let endY = (localEnd.y * mAfterHeight) / mBeforeHeight;
                let angleInDegrees = calculateAngle360(startX, startY, endX, endY);

                let animationFlg = drawArrowLine(startX, startY, endX, endY, line, angleInDegrees);
                line += speed;
                if (animationFlg) {
                    animetionCallbackId = requestAnimationFrame(animateAsync);
                } else {
                    line = lineLength;
                    cancelAnimationFrame(animetionCallbackId);
                    resolve();
                }
            }
            animateAsync();
        });
    };

    // --- 再生処理本体 ---
    async function playSequentially(logs: positionResultType[], startIdx: number = 0) {
        setIsPaused(false);
        let positionLog_buf: positionResultType | undefined = undefined;
        for (let i = startIdx; i < logs.length; i++) {
            setCurrentIndex(i);
            // 一時停止中は待機
            while (isPausedRef.current) {
                await new Promise(resolve => setTimeout(resolve, 100));
                if (!isPlayingRef.current) return;
            }
            if (!isPlayingRef.current) return;

            if (i === 0) {
                drawFirstPoint(logs[i]);
                setMovelist(prev => [
                    ...prev,
                    `${new Date(logs[i].detected).toLocaleString()} 座標:X ${Math.trunc(logs[i].x)},Y ${Math.trunc(logs[i].y)}から開始`
                ]);
            } else {
                await drawDeviceMoveAsync(positionLog_buf!, logs[i]);
                setMovelist(prev => [
                    ...prev,
                    `${new Date(logs[i].detected).toLocaleString()} 座標:X ${Math.trunc(positionLog_buf!.x)},Y ${Math.trunc(positionLog_buf!.y)}から座標:X ${Math.trunc(logs[i].x)},Y ${Math.trunc(logs[i].y)}へ移動`
                ]);
                await new Promise(resolve => setTimeout(resolve, intervalTime));
            }
            positionLog_buf = logs[i];
        }
        setIsPlaying(false);
    }

    // --- 再生ボタンの制御 ---
    const playFunction = () => {
        const playButton = document.getElementById("playButton") as HTMLButtonElement;
        const selectInterval = document.getElementById("selectInterval") as HTMLSelectElement;

        if (!isPlaying) {
            // 初回 or もう一度見る
            setMovelist([]);
            setCurrentIndex(0);
            setIsPlaying(true);
            setIsPaused(false);
            selectInterval.disabled = true;
            playButton.textContent = "再生中";
            canvasClear();
            setMapImage();
            // ここでsetTimeoutを使って次のtickでplaySequentiallyを呼ぶ
            setTimeout(() => {
                playSequentially(props.positionLogs, 0).then(() => {
                    playButton.textContent = "もう一度見る";
                    selectInterval.disabled = false;
                    setIsPlaying(false);
                });
            }, 0);
        } else if (isPlaying && !isPaused) {
            // 一時停止
            setIsPaused(true);
            playButton.textContent = "停止中";
            selectInterval.disabled = false;
        } else if (isPlaying && isPaused) {
            // 再開
            setIsPaused(false);
            playButton.textContent = "再生中";
            selectInterval.disabled = true;
            setTimeout(() => {
                playSequentially(props.positionLogs, currentIndex).then(() => {
                    playButton.textContent = "もう一度見る";
                    selectInterval.disabled = false;
                    setIsPlaying(false);
                });
            }, 0);
        }
    };

    const setLoopInterval = (time: string) => {
        console.log("getNearLoop:" + beaconPositionArray.length)
        setIntervalTime(Number(time));
          // 線の長さ、角度、速度
        if (Number(time) >= 1000) {
            setLinelength(Math.trunc(10000 / Number(time)));
            setSpeed(Math.trunc(10000 / Number(time)));
        } else if (Number(time) >= 100){
            setLinelength(Math.trunc(1000 / Number(time)));
            setSpeed(Math.trunc(1000 / Number(time)));
        } else if (Number(time) >= 10){
            setLinelength(Math.trunc(50 / Number(time)));
            setSpeed(Math.trunc(50 / Number(time)));
        }
        
        
    }

    return(
        <div>
            {}
            <div id="canvas-container" className="canvas-container">
                <canvas className="canvas1" width={800} height={800} ref={canvasRef}></canvas>
                <canvas className="canvas3" width={800} height={800} ref={canvasRef_LineHistory}></canvas>
                <canvas className="canvas2" width={800} height={800} ref={canvasRef_Line}></canvas>
                {
                    //<canvas className="canvas3" width={800} height={800} ref={canvasRef_Name}></canvas>
                }
                
                <canvas className="canvas4" width={800} height={800} ref={canvasRef_Icon}></canvas>
                
            </div>
            
            <div className="description1" id="tooltip" ref={tooltipRef}></div>
            <div>
            
            <Row className="mx-3">
                <Form.Group as={Col}>
                    <Form.Label className="w-20" >再生速度（デフォルト1秒）</Form.Label>
                    <Form.Control as="select" id="selectInterval" className="w-27" onChange={e => setLoopInterval(e.target.value)} >
                        <option value="1000">再生する速度を設定</option>
                        <option value="100">100ミリ秒毎で再生</option>
                        <option value="1000">1秒毎で再生</option>
                        <option value="3000">3秒毎で再生</option>
                        <option value="5000">5秒毎で再生</option>
                    </Form.Control>
                </Form.Group>
            </Row>
            </div>
            <div className="slider-container ">
                <Button className="play-button mt-3 mx-auto mb-2" id="playButton" onClick={playFunction}>
                    軌跡を見る
                </Button>
            </div>
            <div className="card">
                <MoveList listData={moveLists} />
            </div>
        </div>
        
        )
}

export default Canvas